export default "__VITE_ASSET__DR1Y6rm4__"